import $ from 'jquery';
import 'slick-carousel';
import 'arrive';

$(document).ready(function() {
    document.arrive('.block-halfwidth-banner', {existing: true}, function () {
        let $banner = $(this);
        if ($(window).width() < 768) {
            $banner.find('.btn-cta').click(function(e) {
                e.stopPropagation();
            });
            $banner.click(function() {
                $banner.find('.btn-cta')[0].click();
            });
        }
    });
    $('.srg-slick-halfwidth-banner-slider').each(function() {
        let $slider = $(this);
        $slider.slick({
            'slidesToShow': 1,
            'slidesToScroll': 1,
            'infinite': true,
            'dots': false,
            'arrows': false,
            'autoplay': true,
            'autoplaySpeed': 2000,
            'pauseOnHover': false,
            'speed': 500,
            'fade': true,
            'cssEase': 'linear'
        });
    })
})

function fixMobileSectionsFp() {
    if ($(window).width() < 1200) {
        let $hw_banners = $('.block-halfwidth-banner');
        let count_hw_banners = $hw_banners.length;
        if (count_hw_banners > 2) {
            let $hwcc_to_split = $($hw_banners[0]).parents('section.section');
            let count_sections = count_hw_banners / 2;
            count_sections += count_hw_banners % 2 ? 1 : 0;
            let insert_pos = $hwcc_to_split;
            let k = 0;
            for (let i = 0; i < count_sections; i++) {
                let section = $hwcc_to_split[0].cloneNode();
                $(section).append($hwcc_to_split.children('.row')[0].cloneNode());
                let $section_row = $(section).find('.row');
                $($hw_banners[k]).clone().appendTo($section_row);
                if ($hw_banners[k + 1]) {
                    $($hw_banners[k + 1]).clone().appendTo($section_row);
                    k += 2;
                } else {
                    k += 1;
                }
                insert_pos.after(section);
                insert_pos = insert_pos.next();
            }
            $hwcc_to_split.remove();
        }
    }
}

export default {
    fixMobileSectionsFp
}